const FRAME_OPTIONS = [
  { id: 'black', label: 'Black' },
  { id: 'white', label: 'White' },
  { id: 'none', label: 'No Frame' },
];

const MUSEUM_LABEL_OPTIONS = [
  { id: 'white', label: 'White' },
  { id: 'black', label: 'Black' },
  { id: 'gold', label: 'Gold' },
  { id: 'none', label: 'No Museum Label' },
];

function buildLabelMap(optionList) {
  return optionList.reduce((accumulator, option) => {
    accumulator[option.id] = option.label;
    return accumulator;
  }, {});
}

const FRAME_OPTION_LABELS = buildLabelMap(FRAME_OPTIONS);
const MUSEUM_LABEL_OPTION_LABELS = buildLabelMap(MUSEUM_LABEL_OPTIONS);

export {
  FRAME_OPTIONS,
  FRAME_OPTION_LABELS,
  MUSEUM_LABEL_OPTION_LABELS,
  MUSEUM_LABEL_OPTIONS,
};
